var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTickGreen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 26,
    rx: 3,
    fill: "#4CAF50",
    fillOpacity: 0.11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.364 16.1924L20.5564 7L21.9706 8.41421L11.364 19.0208L5 12.6569L6.41422 11.2427L11.364 16.1924Z",
    fill: "#3ADC15"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTickGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tick-green.5cb9a21871fbd14ecaef1cc596b0da73.svg";